<template>
  <div class="container">
    <el-dialog title="" :visible.sync="modalShow" width="520px" :before-close="modalClose" :show-close='false'>
      <div class="tab">
        <div class="on" @click="tab(0)" :style="index==0 ? 'color:#000000' : ''">扫码登录
          <div class="in" v-if="index == 0"></div>
        </div>
        <div class="on" @click="tab(1)" :style="index==1 ? 'color:#000000' : ''">验证码登录
          <div class="in" v-if="index == 1"></div>
        </div>
      </div>
      <div class="content" v-show="index == 0">
        <div class="qrcode" >
          <div class="codeVal" style="position: relative;">
            <div class="codeImg" id="qrcode" alt=""></div>
            <div class="iconImg" style="position: absolute;">
              <img src="/static/home/zzlogo.png" style="width: 30px;height: 30px;border-radius: 4px;"/>
            </div>
            <div class="refresh" v-if="qrstatus" @click="getQrcode()">
              <img class="refreshImg" src="/static/curriculum.png" alt="">
              <div class="refreshVal">二维码失效</div>
              <div class="refreshVal">点击刷新</div>
            </div>
          </div>
          <div class="codeName">打开指正书法APP</div>
          <div class="codeTips">点击【我的】右上角扫一扫</div>
        </div>

      </div>
      <div class="content" v-show="index == 1">
        <el-input placeholder="请输入登录手机号" v-model="phone" style="margin-bottom:30px"></el-input>
        <drag-verify
          :width="338"
          :height="54"
          text="请将滑块拖动到右侧"
          success-text="验证成功"
          background="#f5f5f5"
          progress-bar-bg="#4b0"
          completed-bg="#66cc66"
          handler-bg="#fff"
          handler-icon="el-icon-right"
          text-size="16px"
          success-icon="el-icon-success"
          ref="dragVerify"
          :isPassing.sync="isPassing"
          @passcallback="passcallback2"
        >
        </drag-verify>
        <div class="code">
          <el-input placeholder="请输入验证码" style="width:200px" v-model="code"></el-input>
          <el-button v-if="show" style="width:120px;height:54px;background-color: #F1F1F2;margin-left:14px;" @click="getCode">获取验证码</el-button>
          <el-button v-if="!show" style="width:120px;height:54px;background-color: #F1F1F2;margin-left:14px;">{{count}}</el-button>
        </div>
        <el-button class="submit" @click="submit">确定</el-button>

        <div class="agreement">
          <el-checkbox v-model="checked" style="margin-right: 10px;"></el-checkbox>
          <span>登录即同意指正书法</span>
          <span class="cp" @click="openPrivacy">《隐私政策》</span>
        </div>
        <div class="info">未注册，登录后将自动创建指正书法账号</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
require('vue-video-player/node_modules/video.js/dist/video-js.css')
import dragVerify from './dragVerify.vue'
import QRCode from 'qrcodejs2'

export default {
  data () {
    return {
      timer: null,
      show: true,
      modalShow: false,
      phone: '',
      checked: false,
      count: '',
      code: '',
      isPassing: false,
      index: 0,
      qrCode: '',
      qrtimer: '',
      qrstatus: 'false'
    }
  },
  components: {
    dragVerify
  },
  mounted() {

  },
  methods: {
    tab(e){
      this.index = e
      console.log(this.index)
    },
    reset () {
      console.log('重置滑块')
      this.isPassing = false
      if (this.$refs.dragVerify != undefined) {
        this.$refs.dragVerify.reset()
      }
    },
    passcallback2 () {
      console.log('滑块验证成功走的方法')
    },
    getQrcode(){
      this.$api.sendqrCode().then((res) => {
        if (res.success && res.data) {
          console.log('元素',document.getElementById('qrcode'))
          document.getElementById('qrcode').innerHTML = ''
          let qrcode = new QRCode('qrcode', {
            width: 120,
            height: 120,
            text: res.data.content,
            colorDark: '#000',
            colorLight: '#fff'
          })
          this.qrstatus = false
          this.qrtimer = setInterval(()=>{this.getcodeInfo(res.data.content)},2000)
        }
      })
    },
    getcodeInfo(e){
      this.$api.sendCodeInfo({code:e}).then((res) => {
        if (res.success && res.data) {
          if(res.data.status == -1){
            clearInterval(this.qrtimer)
            this.qrstatus = true
          }else if(res.data.status == 2){
            clearInterval(this.qrtimer)
            this.modalShow = false
            localStorage.setItem('token', res.data.tokenInfo.data.token)

            this.$emit('login', res.data.tokenInfo.data)
            this.$message.success('欢迎来到指正书法！')
          }
        }
      })
    },
    getCode () {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!this.phone) {
        this.$message.warning('请输入手机号')
        return false
      }
      if (!myreg.test(this.phone)) {
        this.$message.warning('请输入正确的手机号')
        return false
      }
      if (!this.isPassing) {
        this.$message.warning('请完成滑块验证')
        return false
      }

      const TIME_COUNT = 60
      if (!this.timer) {
        this.$api.sendCode({phoneNum: this.phone}).then((res) => {
          if (res.success && res.data) {
            this.$message.success('发送成功请耐心等待！')
          }
        })
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    openPrivacy () {
      window.open('https://app.yide111.com/privacy.html', '_blank')
    },
    submit () {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!this.phone) {
        this.$message.warning('请输入手机号')
        return false
      }
      if (!myreg.test(this.phone)) {
        this.$message.warning('请输入正确的手机号')
        return false
      }
      if (!this.isPassing) {
        this.$message.warning('请完成滑块验证')
        return false
      }
      if (!this.code) {
        this.$message.warning('请获取验证码')
        return false
      }
      if (!this.checked) {
        this.$message.warning('请勾选同意协议')
        return false
      }
      this.$api.login({phoneNum: this.phone, code: this.code}).then(res => {
        if (res.success) {
          this.modalShow = false
          localStorage.setItem('token', res.data.token)

          this.$emit('login', res.data)
          this.$message.success('欢迎来到指正书法！')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    init () {
      this.modalShow = true
      this.reset()
      this.phone = ''
      this.checked = false
      this.count = ''
      this.code = ''
      this.isPassing = false
      this.getQrcode()
    },
    modalClose () {
      this.modalShow = false
    }
  }
}
</script>

<style scoped lang="less">
  .container {
    /deep/ .el-dialog__title {
      font-size: 32px;
      font-weight: 600;
    }
    /deep/ .el-dialog__header {
      // padding-top: 30px;
    }
    /deep/ input {
      height: 54px;
      background-color: #F1F1F2;
      font-size: 16px;
    }
    /deep/ .el-button {
      span {
        font-size: 16px;
      }
    }

    .content {
      margin-top: 30px;
      padding: 0 70px;
      height: 420px;
      // padding-bottom: 30px;
    }
    .code {
      margin-top: 30px;
    }
    .submit {
      width: 100%;
      height: 54px;
      background: #D1B07F;
      border-radius: 3px;
      font-weight: 600;
      color: #FFFFFF;
      margin-top: 42px;
      /deep/ span {
        font-size:20px
      }
    }
    .agreement {
      margin-top: 17px;
      text-align: left;
      span {
        font-size: 14px;
      }
      span:first-child {
        color: #999999;

      }
      span:last-child {
        color: #B7905C;
      }
    }
    .info {
      margin-top: 38px;
      font-size: 16px;
      font-weight: 500;
      color: #C94C4C;
    }
  }
  .tab{
    font-size: 23px !important;
    font-weight: 500;
    color: #666666;
    line-height: 37px !important;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-bottom: 30rpx !important;
    .on{
      cursor: pointer;
      height: 37px;
      position: relative;
      .in{
        width: 50px !important;
        height: 3px !important;
        background: #D0AF82;
        margin: 0 auto;
      }
    }
  }
  .qrcode{
    height: 70%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .codeVal{
      width: 165px;
      height: 165px;
      background: #FFFFFF;
      border: 1rpx solid #333333;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .codeImg{
        width: 165px;
        height: 165px;
        flex-shrink: 0;
      }
      .refresh{
        cursor: pointer;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: rgba(255, 255, 255, 0.9);
        .refreshImg{
          width: 29px;
          height: 32px;
          flex-shrink: 0;
        }
        .refreshVal{
          margin-top: 10px;
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          line-height: 18px;
        }
      }
    }
    .codeName{
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      line-height: 18px;
      margin: 15px 0;
    }
    .codeTips{
      font-size: 15px;
      font-weight: 500;
      color: #F90000;
      line-height: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/logo.vue